import { BlockCoreBase } from "./block.core.base"


export class BlockCore extends BlockCoreBase {

}